import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AttestationCrpcenTptDto } from "../../../dto/GenApi.iNotPaie.Dto/AttestationCrpcenTptDto";
import securiteSocialHelper from "../../../Helper/securiteSocialHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalAttestationCrpcenTpt extends Vue {
    @Prop({ required: true })
    public idConge!: number;

    public visible = false;
    public isDataReady = false;
    public isError = false;
    public isClosing = false;
    public isDownloading = false;

    public form = this.getEmptyForm();
    /**
     * Règles de validation du formulaire
     */
    public rules = {
        NomSalarie: [
            { required: true, message: "Veuillez renseigner un nom de famille", trigger: "change" }
        ],
        NomNaissanceSalarie: [
            { required: true, message: "Veuillez renseigner un nom de naissance", trigger: "change" }
        ],
        PrenomSalarie: [
            { required: true, message: "Veuillez renseigner un prénom", trigger: "change" }
        ],
        AdresseSalarie: [
            { required: true, message: "Veuillez renseigner une adresse", trigger: "change" }
        ],
        CodePostalSalarie: [
            { required: true, message: "Veuillez renseigner un code postal", trigger: "change" }
        ],
        CommuneSalarie: [
            { required: true, message: "Veuillez renseigner une commune", trigger: "change" }
        ],
        NumeroSecuriteSocialeSalarie: [
            { required: true, message: "Veuillez renseigner un numéro de sécurité sociale", trigger: "change" }
        ],
        DateDebutAbsence: [
            { required: true, message: "Veuillez renseigner une date de début du TPT", trigger: "change" }
        ],
        DateFinAbsence: [
            { required: true, message: "Veuillez renseigner une date de fin du TPT", trigger: "change" }
        ],
        MontantPerteSalaireBrut: [
            { required: true, message: "Veuillez renseigner le montant de la perte de salaire brut", trigger: "change" }
        ]
    };

    public mounted(): void {
        if (!this.idConge) {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des informations nécessaires à l'attestation CRPCEN.");
            this.hide();
            return;
        }

        this.visible = true;

        ServicesFactoryInstance.AbsencesService.getAttestationCrpcenTpt(this.idConge, (data) => {
            this.setFormData(data);
            this.isDataReady = true;

            this.$nextTick(() => {
                // Evite d'avoir un message d'erreur sur tout champ vide à l'ouverture de la popup
                (this.$refs.form as any).clearValidate();
            });
        }, () => {
            this.isError = true;
            this.isDataReady = false;
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des informations nécessaires à l'attestation CRPCEN.");
        });
    }

    /**
     * Méthode pour masquer le modal
     * @returns {void}
     */
    public hide(): void {
        this.$emit("closeModal");
    }

    /**
     * Rempli le formulaire avec les informations nécessaires à l'attestation CRPCEN
     * @returns {void}
     */
    private setFormData(absenceInfo: AttestationCrpcenTptDto): void {
        Object.assign(this.form, absenceInfo);
        this.form.NumeroSecuriteSocialeSalarie = securiteSocialHelper.formatNumeroSecuriteSocial(absenceInfo.NumeroSecuriteSocialeSalarie ?? "");
        this.form.IdConge = this.idConge;
    }

    /**
     * Initialise un formulaire vide
     * @returns Un formulaire vide
     */
    private getEmptyForm(): AttestationCrpcenTptDto {
        return {
            IdConge: undefined,
            NomSalarie: undefined,
            NomNaissanceSalarie: undefined,
            PrenomSalarie: undefined,
            AdresseSalarie: undefined,
            CommuneSalarie: undefined,
            CodePostalSalarie: undefined,
            NumeroSecuriteSocialeSalarie: undefined,
            NumeroTelephoneSalarie: undefined,
            DateDebutAbsence: undefined,
            DateFinAbsence: undefined,
            MontantPerteSalaireBrut: undefined,
            Subrogation: false
        };
    }

    /**
     * Ouvre un blob pour enregistrer l'attestation générée
     * @param data
     */
    private save(data: Blob): void {
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(data);
        link.download = "Attestation Temps Partiel Thérapeutique CRPCEN";
        link.click();
        document.body.removeChild(link);
    }

    public telechargerAttestation(): void {
        const form = this.$refs["form"] as any;
        form.validate((valid: boolean) => {
            if (!valid) return;

            this.isClosing = true;
            this.isDownloading = true;
            ServicesFactoryInstance.AbsencesService.generationAttestationCrpcenTpt(this.form, (data) => {
                this.save(data);
                this.hide();
            }, () => {
                this.isClosing = false;
                this.isDownloading = false;
                NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la génération de l'attestation CRPCEN.");
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/calendrier/modalAttestationCrpcenTpt/modalAttestationCrpcenTpt.ts